import config from '../../config/generated.json'

function isAppWhiteLabeled(): boolean {
  return config.isWhiteLabel
}

export default isAppWhiteLabeled
